/** Number of avatar colours; app.module.css defines one per tone. */
export const AVATAR_TONES = 4;

/** Initials of the first and last word, e.g. "Erika Musterfrau" → "EM". */
export function initials(name: string): string {
  const words = name.trim().split(/\s+/).filter((word) => word !== '');
  const picked = words.length > 1 ? [words[0], words[words.length - 1]] : words;
  const letters = picked.map((word) => [...(word ?? '')][0] ?? '').join('');
  return letters === '' ? '?' : letters.toUpperCase();
}

/** A stable colour per person: djb2 over the e-mail, so two people with the same initials usually differ. */
export function avatarTone(email: string): number {
  let hash = 5381;
  for (const char of email.trim().toLowerCase()) hash = ((hash * 33) ^ (char.codePointAt(0) ?? 0)) >>> 0;
  return hash % AVATAR_TONES;
}
